import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { TemplateSubmissionFields } from 'components/ReviewTemplateFormModal/Types'
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query'
import { ReviewTemplate } from 'types'
import { reviewTemplateKeys } from './reviewTemplateKeys'

export interface UseCreateReviewTemplateProps
  extends UseMutationOptions<ReviewTemplate, unknown, TemplateSubmissionFields> {
  workspaceId: number
}

interface CreateReviewTemplateResponse {
  review_template: ReviewTemplate
}

export const useCreateReviewTemplate = ({ workspaceId, ...options }: UseCreateReviewTemplateProps) => {
  const client = useQueryClient()
  const onSuccess = (template: ReviewTemplate, variables: TemplateSubmissionFields, context: unknown) => {
    client.invalidateQueries(reviewTemplateKeys.list(workspaceId))
    options.onSuccess?.(template, variables, context)
  }
  return useMutation<ReviewTemplate, unknown, TemplateSubmissionFields>(
    async (fields: TemplateSubmissionFields) => {
      const res = await sendToApi<CreateReviewTemplateResponse>(`/w/${workspaceId}/review_templates`, {
        method: 'POST',
        body: fields,
      })
      if (res.type !== SUCCESS_RESPONSE_TYPE) throw new Error()
      return res.data.review_template
    },
    { ...options, onSuccess },
  )
}
